import newsService from '@/api/newsService'
const state = {
    // 新闻列表
    newsList: [],
    // 新闻详情
    newsDetail: {}
}
const mutations = {
    // 设置新闻列表
    SET_NEWS_LIST: (state, data) => {
        state.newsList = data.list || []
    },
    SET_NEWS_DETAIL: (state, data) => {
        state.newsDetail = data.detail || {}
    }
}
const actions = {
    // 获取新闻列表
    getNewsList({ commit }, params) {
        return new Promise((resolve, reject) => {
            newsService.fetchNewsList(params)
                .then(res => {
                    const { data } = res
                    resolve(data)
                    commit('SET_NEWS_LIST', data)
                })
        })
    },
    // 获取新闻详情
    getNewsDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            newsService.fetchNewsDetail(params)
                .then(res => {
                    const { data } = res
                    resolve(data)
                    commit('SET_NEWS_DETAIL', data)
                })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/news.js